import React from "react";

// import socials
import { SOCIALS } from "../../helpers/constants";

// import app logo
import logo from "../../assets/images/logos/logo.png";

// import app name
import { APP_NAME } from "../../helpers/constants";

const Footer = () => {
  return (
    <footer id="" className="container-fluid pt-12 px-0">
      <div className="footer flex w-full py-8 lg:px-32 xl:px-44">
        <div className="container flex flex-col space-y-4 justify-center items-center">
          <div className="flex flex-col w-full">
            <div className="container p-0 flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-12">
              <img
                id="logo-app"
                src={logo}
                alt="app logo"
                className="h-16 w-16"
              />
              <div className="flex flex-col justify-center space-y-4 md:space-y-2 w-full">
                <div className="flex flex-col space-y-2 md:space-y-0">
                  <ul className="grid grid-cols-3 gap-3 md:flex md:flex-wrap md:justify-between md:items-center px-0">
                    <li className="md:w-auto">
                      <a href="#">Annuaire</a>
                    </li>
                    <li className="md:w-auto">
                      <a href="#">Opportunités</a>
                    </li>
                    <li className="md:w-auto">
                      <a href="#">Orientation</a>
                    </li>
                    <li className="md:w-auto">
                      <a href="#">Métiers</a>
                    </li>
                    <li className="md:w-auto">
                      <a href="#">Partenariat</a>
                    </li>
                    <li className="md:w-auto">
                      <a href="#">Mon compte</a>
                    </li>
                  </ul>
                  <div className="border-b border-1 border-[#12CFEF1F]" />
                </div>
                <div className="w-auto">
                  <ul className="next_links flex flex-col space-y-4 md:space-y-0 md:space-x-8 md:flex-row justify-center items-center">
                    <li>
                      <a href="#">Calendrier</a>
                    </li>
                    <li>
                      <a href="#">Quiz</a>
                    </li>
                    <li>
                      <a href="#">Conseils</a>
                    </li>
                    <li>
                      <a href="#">Groupes privés</a>
                    </li>
                    <li>
                      <a href="#">Ambassadeurs ACE</a>
                    </li>
                    <li>
                      <a href="#">Contact – FAQ</a>
                    </li>
                    <li>
                      <a href="#">CGU</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-socials">
            <div className="footer-contact flex flex-col justify-center items-center space-y-2">
              <h4 className="text-center">
                Suivez-nous sur les réseaux sociaux
              </h4>
              <div className="center-box">
                <div className="social-links flex space-x-2">
                  {SOCIALS.map((social, index) => (
                    <a
                      key={`social_network_${index}`}
                      href={social.link}
                      className={social.name}
                    >
                      <i className={`bx bxl-${social.icon}`} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center py-1 bg-[#f2f2f2]">
        <div className="copyright container">
          &copy; 2021 <span className="font-medium">ACE Orientation</span> Tous
          droits réservés - Reproduction du contenu interdite
        </div>
      </div>
    </footer>
  );
};
export default Footer;
